module.exports = __webpack_public_path__ + "img/Ballons_pour_mariage.ff54c62.jpg";